import React from "react";
import ToBack from "../components/ToBack";

const AvatarUpload = () => {
  const [file, setFile] = React.useState(null);
  const [preview, setPreview] = React.useState(null);
  const [resumeID, setResumeID] = React.useState(null);
  const auth = JSON.parse(localStorage.getItem("auth"));

  React.useEffect(() => {
    if (!auth) {
      location.href = "#/登录";
    }
  }, []);

  React.useEffect(() => {
    if (!file) {
      setPreview(null);
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  }, [file]);

  React.useEffect(() => {
    (async (id) => {
      const response = await fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`);
      const data = await response.json();
      setResumeID(data.id);
      try {
        const avatar = JSON.parse(data.json_doc).avatar;
        if (avatar) {
          setPreview(avatar);
        }
      } catch (err) {
        console.error(err);
      }
    })(auth.id);
  }, [auth.id]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      if (selectedFile.size > 2097152) {
        alert("请上传2M以内的图片文件");
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleUpload = () => {
    if (!file) {
      alert("请选择图片文件");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      fetch(`/gin-api/resume/0/${resumeID}?option=avatar`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ avatar: base64String }),
      }).then((res) => {
        if (res.ok) {
          alert("上传成功");
          location.href = "#/我的/简历";
        } else {
          alert("上传失败");
        }
      });
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="container-fluid">
      <ToBack category="上传头像" />
      <div className="text-center mt-4">
        <div
          style={{
            width: 120,
            height: 120,
            margin: "0 auto",
            overflow: "hidden",
            borderRadius: "50%",
            background: "#f0f0f0",
          }}
        >
          {preview ? (
            <img
              src={preview}
              alt="preview"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <div style={{ lineHeight: "120px", color: "#999" }}>预览</div>
          )}
        </div>
        <div className="mt-3">
          <input
            type="file"
            id="avatarFile"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <button
            className="btn btn-primary"
            onClick={() => document.getElementById("avatarFile").click()}
          >
            选择图片
          </button>
        </div>
        <div className="mt-3">
          <button className="btn btn-success" onClick={handleUpload}>
            上传
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvatarUpload;
